var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.57 26.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1db2d7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,15.57v-2C1.44,11,3.17,10.41,5.53,11.72c0,0,.09,0,.17,0,0-2.76,0-5.51,0-8.27A3.27,3.27,0,0,1,8.05.22L8.7,0h.71c.06,0,.1.1.16.12a3.35,3.35,0,0,1,2.84,3.55V9.22l5.5,1.22a5.2,5.2,0,0,1,4,3.15A12.29,12.29,0,0,1,22.13,21a44,44,0,0,1-2.31,5.9H8.27c-.17-.39-.37-.76-.52-1.16a17.56,17.56,0,0,0-4.86-6.78A10.71,10.71,0,0,1,0,15.57Zm8,1.56-.18.08c-1.1-1.12-2.19-2.24-3.3-3.34a1.23,1.23,0,0,0-1.83-.11,1.2,1.2,0,0,0,.1,1.82c.73.75,1.43,1.53,2.22,2.22A15.62,15.62,0,0,1,9.45,24a.81.81,0,0,0,.91.58c2.33,0,4.66-.05,7,0,.76,0,1-.28,1.33-.91a14.56,14.56,0,0,0,1.48-7.65,3.37,3.37,0,0,0-2.68-3.38c-2.17-.5-4.34-1-6.53-1.44-.69-.14-.84-.42-.83-1.08,0-2.19,0-4.38,0-6.57A1.1,1.1,0,0,0,8.55,2.47,1.14,1.14,0,0,0,8,3.66C8,7.9,8,12.13,8,16.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/Hand.1726ff4a8ab62cff0c90af933e325507.svg";
export { ForwardRef as ReactComponent };